import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HTTPCONSTANTS} from '../http/http-constants';
import {HttpService} from '../http/http-service';
import {Registration} from '../models/registration';
import {SoldPlate} from '../models/soldPlate';
import {LoggerService} from './logger-service';
import {UserService} from './user-service';

export class PayablePlate {
  public date: Date;
  public clickDate: Date;
  public registration: string;
  public formattedRegistration: string;
  public url: string;
  public dealer: string;

  public sold: boolean
  public sold_date: Date;

  constructor() {
  }

  public addDate(date: Date): PayablePlate {
    this.clickDate = date;
    return this;
  }
}

export class DealerMetric {
  constructor(public date: Date,
              // non dvla
              public clicks: number,
              public impressions: number,
              public affiliateClicks: number,
              public payableClicks: number,
              public payablePlates: PayablePlate[],
              // dvla
              public dvlaImpressions: number,
              public dvlaClicks: number,
              public dvlaAffiliateClicks: number,
              public dvlaPayableClicks: number,
              public dvlaPayablePlates: PayablePlate[]) {
  }
}

export class DealerMetrics {
  constructor(public metrics: DealerMetric[]) {
  }
}

export class DealerRegistrationResponse {
  public registrations: DealerRegistration[];
  public pagination: {
    page: number;
    total: number;
  } = {
    page: 1,
    total: 0
  }
}

export class DealerRegistration {
  public id: number;
  public registration: string;
  public formatted_registration: string;
  public price_minor: number;
  public markup_minor: number;
  public style: string
  public sole_supplier: boolean;
  public date_added: Date;
  public is_active: boolean
  public last_updated: Date;
}

@Injectable({providedIn: 'root'})
export class DealerService {
  private userLoaded: boolean = false;
  private waitingCallbacks: any[] = [];

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private loggerService: LoggerService,
    private httpService: HttpService
  ) {
    this.userService.fetchAllUserData(() => {
      this.userLoaded = true;
      this.waitingCallbacks.forEach(c => c());
    });
  }

  private UserCheckCallback(callback: any): void {
    if (this.userLoaded) callback();
    else this.waitingCallbacks.push(callback);
  }

  public refreshMetrics(callback: () => void): void {
    this.http.get<any>(`${HTTPCONSTANTS.plato_search_protocol}${HTTPCONSTANTS.plato_search_base}?process=dealer-set-stock`).subscribe(callback, callback);
  }

  public GetDealerList(
    callback: (data: { site_name: string, view_name: string }[]) => void,
    errCallback: (error: any) => void = (error: any) => {
    }
  ): void {
    this.http.get<{
      site_name: string,
      view_name: string
    }[]>(`${HTTPCONSTANTS.plato_search_protocol}${HTTPCONSTANTS.plato_search_base}?process=dealer-list`).subscribe((data: {
      site_name: string,
      view_name: string
    }[]) => {
      callback(data);
    }, (err: any) => {
      errCallback(err);
    });
  }

  public GetDealerInfo(
    dealer: string,
    callback: (data: { dealerName: string, dealer: string }) => void,
    errCallback: (error: any) => void = (error: any) => {
    }
  ): void {
    this.http.get<{
      dealerName: string,
      dealer: string
    }>(`${HTTPCONSTANTS.plato_search_protocol}${HTTPCONSTANTS.plato_search_base}?process=dealer-info&dealer=${dealer}`).subscribe((data: {
      dealerName: string,
      dealer: string
    }) => {
      callback(data);
    }, (err: any) => {
      errCallback(err);
    });
  }

  public GetDealerStockMetrics(
    dealer: string,
    range: string,
    callback: (data: DealerMetrics) => void,
    errCallback: (error: any) => void = (error: any) => {
    }
  ): void {
    this.http.get<DealerMetrics>(`${HTTPCONSTANTS.plato_search_protocol}${HTTPCONSTANTS.plato_search_base}?process=dealer-stock-metrics&range=${range}&dealer=${dealer}`).subscribe((data: DealerMetrics) => {
      callback(data);
    }, (err: any) => {
      errCallback(err);
    });
  }

  public GetDealerStockInfo(
    dealer: string,
    callback: (data: { stockCount: number, stockValue: number }) => void,
    errCallback: (error: any) => void = (error: any) => {
    }
  ): void {
    this.http.get<{
      stockCount: number,
      stockValue: number
    }>(`${HTTPCONSTANTS.plato_search_protocol}${HTTPCONSTANTS.plato_search_base}?process=dealer-stock-info&dealer=${dealer}`).subscribe((data: {
      stockCount: number,
      stockValue: number
    }) => {
      callback(data);
    }, (err: any) => {
      errCallback(err);
    });
  }

  public GetDealerStockTable(
    dealer: string,
    query: string,
    order: string,
    direction: string,
    page: string,
    callback: (data: DealerRegistrationResponse) => void,
    errCallback: (error: any) => void = (error: any) => {
    }
  ): void {
    this.http.get<DealerRegistrationResponse>(`${HTTPCONSTANTS.plato_search_protocol}${HTTPCONSTANTS.plato_search_base}?process=dealer-stock-table&query=${query}&page=${page}&order=${order}&direction=${direction}&dealer=${dealer}`).subscribe((data: DealerRegistrationResponse) => {
      callback(data);
    }, (err: any) => {
      errCallback(err);
    });
  }
}
